'use strict';

let util = require('../core/util');

/**
 * @class AccountService
 */
module.exports = class AccountService {

    constructor(param) {
        const init = util.buildInitParam(param);

        this.EVENT_ACCOUNT_FETCHED = 'account:fetched';
        this.EVENT_ACCOUNT_UPDATED = 'account:updated';

        this._EventBus = init._EventBus;

        this._customerUrl = function(customerId){
            return init.baseUrl + init.restPrefix + init.abcGatewayPrefix + 'customers/' + customerId;
        }

        this._customerGroupByNameUrl = name => {
            return `${init.baseUrl + init.restPrefix + init.abcGatewayPrefix}customer-groups/name=${name}`;
        };
        
        this._customerGroupByIdUrl = id => {
            return `${init.baseUrl + init.restPrefix + init.abcGatewayPrefix}customer-groups/${id}`;
        };
    }

    /**
     * get customer
     * @param {String} customerId 
     */
    getCustomerById(customerId){
        var _this = this;
        return util.makeGETRequest(this._customerUrl(customerId)).then(function(res){
            if(res.id){
                _this._EventBus.dispatch(_this.EVENT_ACCOUNT_FETCHED, res);
            }
            return res;
        });
    }

    /**
     * Update Customer Meta Info
     * @param {Object} customerMeta 
     * @param {Object} info 
     */
    updateCustomerInfo(customerMeta, info){
        let actions = [];
        if(!util.typeOf(info, 'object')){
            return util.sendValidationError(new Error('Invalid info parameter'));
        }
        if(util.typeOf(info.email, 'string')){
            actions.push({
                action: 'changeEmail',
                email: info.email
            });
        }
        if(!util.typeOf(info.firstName, 'undefined')){
            actions.push({
                action: 'setFirstName',
                firstName: info.firstName
            });
        }
        if(!util.typeOf(info.lastName, 'undefined')){
            actions.push({
                action: 'setLastName',
                lastName: info.lastName
            });
        }
        if(!util.typeOf(info.middleName, 'undefined')){
            actions.push({
                action: 'setMiddleName',
                middleName: info.middleName
            });
        }
        if(!util.typeOf(info.title, 'undefined')){
            actions.push({
                action: 'setTitle',
                title: info.title
            });
        }
        if(!util.typeOf(info.salutation, 'undefined')){
            actions.push({
                action: 'setSalutation',
                salutation: info.salutation
            });
        }
        if(!util.typeOf(info.customerNumber, 'undefined')){
            actions.push({
                action: 'setCustomerNumber',
                customerNumber: info.customerNumber
            });
        }
        if(!util.typeOf(info.companyName, 'undefined')){
            actions.push({
                action: 'setCompanyName',
                companyName: info.companyName
            });
        }
        if(!util.typeOf(info.externalId, 'undefined')){
            actions.push({
                action: 'setExternalId',
                externalId: info.externalId
            });
        }
        if(util.typeOf(info.addShippingAddressId, 'string')){
            actions.push({
                action: 'addShippingAddressId',
                addressId: info.addShippingAddressId
            });
        }
        if(util.typeOf(info.removeShippingAddressId, 'string')){
            actions.push({
                action: 'removeShippingAddressId',
                addressId: info.removeShippingAddressId
            });
        }
        if(util.typeOf(info.addBillingAddressId, 'string')){
            actions.push({
                action: 'addBillingAddressId',
                addressId: info.addBillingAddressId
            });
        }
        if(util.typeOf(info.removeBillingAddressId, 'string')){
            actions.push({
                action: 'removeBillingAddressId',
                addressId: info.removeBillingAddressId
            });
        }
        if(util.typeOf(info.dateOfBirth, 'null') || util.typeOf(info.dateOfBirth, 'date')){
            actions.push({
                action: 'setDateOfBirth',
                dateOfBirth: info.dateOfBirth ? info.dateOfBirth.toISOString().replace(/T.*/,'') : info.dateOfBirth
            });
        }
        if(util.typeOf(info.customerGroup, 'object')){
            actions.push({
                action: 'setCustomerGroup',
                customerGroup: info.customerGroup
            });
        }
        if(actions.length === 0){
            return util.sendValidationError(new Error('Unsupported info parameter'));
        }
        return this.updateCustomer(customerMeta, actions);
    }

    /**
     * Update Customer Info
     * @param {Object} customerMeta 
     * @param {Array} actions 
     */
    updateCustomer(customerMeta, actions){
        var request = {
            "version":customerMeta.version, 
            "actions":actions
        };
        return util.makePostRequest(this._customerUrl(customerMeta.id), request).then(this._dispatchIsUpdated.bind(this));
    }

    /**
     * Dispatch Customer Updated Event
     * @param {Object} res 
     */
    _dispatchIsUpdated(res){
        if(res.id){
            this._EventBus.dispatch(this.EVENT_ACCOUNT_UPDATED, res);
        }
        return res;
    }

    /**
     * Add Address
     * 
     * @param {Object} customerMeta 
     * @param {Object} address 
     */
    addAddress(customerMeta, address){
        if(!util.typeOf(address, 'object') || !address.country){
            return util.sendValidationError(new Error('Invalid address parameter'));
        }
        return this.updateCustomer(customerMeta, [{
            'action':'addAddress',
            'address':address
        }]);
    }

    /**
     * Add Shipping Address
     * @param {Object} customerMeta 
     * @param {Object} address 
     * @param {Boolean} setDefault 
     */
    addShippingAddress(customerMeta, address, setDefault){
        var _this = this;
        if(!address.externalId){
            address.externalId = ((new Date()).getTime().toString());
        }
        return _this.addAddress(customerMeta, address).then(function(_customer){
            if(_customer.id){
                // Address Added, Now Add this address to Shipping Address Ids
                var _address = util.searchFirstByKeyValue(_customer.addresses, 'externalId', address.externalId);
                if(_address.id){
                    // found Id of newly added Adddress
                    var actions = [{
                        "action": "addShippingAddressId",
                        "addressId": _address.id
                    }];
                    if(setDefault){
                        actions.push({
                            "action": "setDefaultShippingAddress",
                            "addressId": _address.id
                        });
                    }
                    return _this.updateCustomer(_customer, actions);
                }
            }
            return _customer;
        });
    }

    /**
     * Add Billing Address
     * @param {Object} customerMeta 
     * @param {Object} address 
     * @param {Boolean} setDefault 
     */
    addBillingAddress(customerMeta, address, setDefault){
        var _this = this;
        if(!address.externalId){
            address.externalId = ((new Date()).getTime().toString());
        }
        return _this.addAddress(customerMeta, address).then(function(_customer){
            if(_customer.id){
                // Address Added, Now Add this address to Billing Address Ids
                var _address = util.searchFirstByKeyValue(_customer.addresses, 'externalId', address.externalId);
                if(_address.id){
                    // found Id of newly added Adddress
                    var actions = [{
                        "action": "addBillingAddressId",
                        "addressId": _address.id
                    }];
                    if(setDefault || util.typeOf(setDefault, 'undefined')){
                        actions.push({
                            "action": "setDefaultBillingAddress",
                            "addressId": _address.id
                        });
                    }
                    return _this.updateCustomer(_customer, actions);
                }
            }
            return _customer;
        });
    }

    /**
     * Set a Address as Default Shipping Address
     * @param {Object} customerMeta 
     * @param {String} addressId 
     */
    setDefaultShippingAddress(customerMeta, addressId){
        return this.updateCustomer(customerMeta, [{
            'action':'setDefaultShippingAddress',
            'addressId':addressId
        }]);
    }
    
    /**
     * Set a Address as Default Billing Address
     * @param {Object} customerMeta 
     * @param {String} addressId 
     */
    setDefaultBillingAddress(customerMeta, addressId){
        return this.updateCustomer(customerMeta, [{
            'action':'setDefaultBillingAddress',
            'addressId':addressId
        }]);
    }

    /**
     * Add Customer's Company Address
     * 
     * @param {Object} customerMeta 
     * @param {Object} address 
     */
    addCompanyAddress(customerMeta, address){
        var _this = this;
        if(!address.externalId){
            address.externalId = ((new Date()).getTime().toString());
        }
        return _this.addAddress(customerMeta, address).then(function(_customer){
            if(_customer.id){
                // Address Added, Now Add this address to Shipping Address Ids
                var _address = util.searchFirstByKeyValue(_customer.addresses, 'externalId', address.externalId);
                if(_address.id){
                    // found Id of newly added Adddress
                    var actions = [{
                        "action": "setCustomField",
                        "name": "companyAddressId",
                        "value": _address.id
                    }];
                    return _this.updateCustomer(_customer, actions);
                }
            }
            return _customer;
        });
    }

    /**
     * get Customer's Company Address Object
     * @param {Object} customer 
     */
    getCompanyAddress(customer){
        if(!util.typeOf(customer, 'object') || !customer.id){
            return util.sendValidationError(new Error('Invalid customer parameter'));
        }
        let _address = {};
        if(customer.custom && customer.custom.fields && customer.custom.fields.companyAddressId && customer.addresses){
            _address = util.searchFirstByKeyValue(customer.addresses, 'id', customer.custom.fields.companyAddressId);
        }
        return Promise.resolve(_address);
    }

    /**
     * Update Customer Address By Id
     * @param {Object} customerMeta 
     * @param {String} addressId 
     * @param {Object} address 
     */
    updateAddress(customerMeta, addressId, address){
        if(!util.typeOf(address, 'object') || !address.country){
            return util.sendValidationError(new Error('Invalid address parameter'));
        }
        return this.updateCustomer(customerMeta, [{
            'action':'changeAddress',
            'addressId': addressId,
            'address':address
        }]);
    }

    /**
     * Remove Customer Address by ID
     * @param customerMeta
     * @param addressId
     */
    removeAddress(customerMeta, addressId){
        if(!util.typeOf(addressId, 'string') || !addressId){
            return util.sendValidationError(new Error('Invalid address id parameter'));
        }
        return this.updateCustomer(customerMeta, [{
            'action':'removeAddress',
            'addressId':addressId
        }]);
    }

    /**
     * get Customer groups by name
     * @param {String} name 
     */
    getCustomerGroupsByName(name){
        return util.makeGETRequest(this._customerGroupByNameUrl(name)); 
    }

    /**
     * get Customer groups by id
     * @param {String} groupId 
     */
    getCustomerGroupById(groupId){
        return util.makeGETRequest(this._customerGroupByIdUrl(groupId)); 
    }
}



// WEBPACK FOOTER //
// ./src/account/AccountService.js